/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Information about our feature flag provider
 */
export type LaunchDarklyConfig = {
  /**
   * LaunchDarkly client side ID
   */
  clientSideId: string;
};

/** @internal */
export const LaunchDarklyConfig$inboundSchema: z.ZodType<
  LaunchDarklyConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  client_side_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "client_side_id": "clientSideId",
  });
});
/** @internal */
export type LaunchDarklyConfig$Outbound = {
  client_side_id: string;
};

/** @internal */
export const LaunchDarklyConfig$outboundSchema: z.ZodType<
  LaunchDarklyConfig$Outbound,
  z.ZodTypeDef,
  LaunchDarklyConfig
> = z.object({
  clientSideId: z.string(),
}).transform((v) => {
  return remap$(v, {
    clientSideId: "client_side_id",
  });
});

export function launchDarklyConfigToJSON(
  launchDarklyConfig: LaunchDarklyConfig,
): string {
  return JSON.stringify(
    LaunchDarklyConfig$outboundSchema.parse(launchDarklyConfig),
  );
}
export function launchDarklyConfigFromJSON(
  jsonString: string,
): SafeParseResult<LaunchDarklyConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LaunchDarklyConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LaunchDarklyConfig' from JSON`,
  );
}
